import { AddEntityButton } from "features/entities/AddEntityButton";
import { EntitiesTableContent } from "features/entities/EntitiesTableContent";
import { FundFamilySetupEntitiesTabProps } from "features/fund-family/setup/entities/FundFamilySetupEntitiesTabProps";
import { useTranslation } from "react-i18next";
import { useOutletContext } from "react-router-dom";
import { PageTabBody } from "shared/components/layout/PageTabBody";
import { TableBox } from "shared/components/table/box/TableBox";
import { TableBoxHeader } from "shared/components/table/box/TableBoxHeader";
import { TableBoxTitle } from "shared/components/table/box/TableBoxTitle";
import { DataTableBoxActions } from "shared/components/table/data/DataTableBoxActions";

export const FundFamilySetupEntitiesTabList: React.FC = () => {
  const { t } = useTranslation(["common"]);
  const { fundFamilyId } = useOutletContext<FundFamilySetupEntitiesTabProps>();
  return (
    <PageTabBody>
      <TableBox>
        <TableBoxHeader>
          <TableBoxTitle>{t("common:entities")}</TableBoxTitle>
          <DataTableBoxActions>
            <AddEntityButton size="xs" fundFamilyId={fundFamilyId} />
          </DataTableBoxActions>
        </TableBoxHeader>
        <EntitiesTableContent fundFamilyId={fundFamilyId} />
      </TableBox>
    </PageTabBody>
  );
};
